/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'sarsaparilla';

export default class InformationRequired extends React.PureComponent {
    static propTypes = {
        divisionType: PropTypes.string,
        hasTypeRequirement: PropTypes.bool,
        hasSizeRequirement: PropTypes.bool,
        hasStartingAreaRequirement: PropTypes.bool,
    };

    static defaultProps = {
        hasTypeRequirement: false,
        hasSizeRequirement: false,
        hasStartingAreaRequirement: false,
    };

    renderRequirements() {
        const { hasTypeRequirement, hasSizeRequirement, hasStartingAreaRequirement } =
            this.props;

        const Type = (
            <span>
                a <strong>Permit Type</strong>
            </span>
        );
        const Group = (
            <span>
                a <strong>Group Size</strong>
            </span>
        );
        const StartingArea = (
            <span>
                a <strong>Starting Area</strong>
            </span>
        );
        const requirements = [];

        if (hasTypeRequirement) {
            requirements.push({ key: 1, content: Type });
        }

        if (hasSizeRequirement) {
            requirements.push({ key: 2, content: Group });
        }

        if (hasStartingAreaRequirement) {
            requirements.push({ key: 3, content: StartingArea });
        }

        if (requirements.length === 3) {
            const allButLast = requirements.slice(0, requirements.length - 1);

            return (
                <>
                    {allButLast.map((item) => {
                        return <span key={item.key}>{item.content}, </span>;
                    })}
                    <span> and {requirements[requirements.length - 1].content}</span>
                </>
            );
        }

        if (requirements.length === 2) {
            return (
                <>
                    {requirements[0].content} and {requirements[1].content}
                </>
            );
        }

        return requirements[0].content;
    }

    render() {
        const {
            divisionType,
            hasTypeRequirement,
            hasSizeRequirement,
            hasStartingAreaRequirement,
        } = this.props;
        const hasARequirement =
            hasTypeRequirement || hasSizeRequirement || hasStartingAreaRequirement;

        return (
            <div className="permit-information-required">
                <div className="permit-information-required-wrap">
                    <Icon iconName="info-outline" size="xl" />
                    <h2 className="permit-information-required-heading">
                        Information Required
                    </h2>
                    {hasARequirement && (
                        <p>
                            Please enter {this.renderRequirements()} to view available{' '}
                            {divisionType.toLowerCase()} for your trip.
                        </p>
                    )}
                </div>
            </div>
        );
    }
}
